import { useCallback } from 'react';

import useModularPdp from 'global-state/modularPdp/useModularPdp';
import useSetModularPdp from 'global-state/modularPdp/useSetModularPdp';

const useModularPDPVar = () => {
  const modularCacheData = useModularPdp();
  const setModularPdp = useSetModularPdp();

  const setModularSlug = useCallback(
    slug => {
      setModularPdp(prevModularPdp => ({
        ...prevModularPdp,
        modularParentSlug: slug,
      }));
    },
    [setModularPdp]
  );

  const setModularCollectionTitle = useCallback(
    title => {
      setModularPdp(prevModularPdp => ({
        ...prevModularPdp,
        collectionTitle: title,
      }));
    },
    [setModularPdp]
  );

  const setModularPrice = useCallback(
    price => {
      setModularPdp(prevModularPdp => ({
        ...prevModularPdp,
        modularTotalPrice: price,
      }));
    },
    [setModularPdp]
  );

  const setModularBundledProducts = useCallback(
    (products = []) => {
      setModularPdp(prevModularPdp => ({
        ...prevModularPdp,
        bundleProducts: products,
      }));
    },
    [setModularPdp]
  );

  const setModularPreConfigProducts = useCallback(
    products => {
      setModularPdp(prevModularPdp => ({
        ...prevModularPdp,
        preConfiguredProducts: products,
      }));
    },
    [setModularPdp]
  );

  const setModularParentOrientationOptions = useCallback(
    orientationOpts => {
      setModularPdp(prevModularPdp => ({
        ...prevModularPdp,
        modularParentOrientationOptions: orientationOpts,
      }));
    },
    [setModularPdp]
  );

  const setModularSectionalProduct = useCallback(
    sectionalProduct => {
      setModularPdp(prevModularPdp => ({
        ...prevModularPdp,
        modularSectionalProduct: sectionalProduct,
      }));
    },
    [setModularPdp]
  );

  const updateCurrentModularGalleryProduct = useCallback(
    updatedProduct => {
      if (updatedProduct) {
        setModularPdp(prevModularPdp => ({
          ...prevModularPdp,
          currentModularGalleryProduct: updatedProduct,
        }));
      }
    },
    [setModularPdp]
  );

  const updateAddProductSideBarIsOpen = useCallback(
    isOpen => {
      setModularPdp(prevModularPdp => ({
        ...prevModularPdp,
        isModularAddProductSidebarOpen: isOpen,
      }));
    },
    [setModularPdp]
  );

  const updateModularBundleOrderStatus = useCallback(
    updatedModularOrder => {
      if (updatedModularOrder) {
        setModularPdp(prevModularPdp => ({
          ...prevModularPdp,
          modularBundleOrderStatus: updatedModularOrder,
        }));
      }
    },
    [setModularPdp]
  );

  const updateModularTotalPrice = useCallback(
    updatedPrice => {
      setModularPdp(prevModularPdp => ({
        ...prevModularPdp,
        modularTotalPrice: updatedPrice,
      }));
    },
    [setModularPdp]
  );

  return {
    data: {
      modularState: modularCacheData,
    },
    actions: {
      setModularSlug,
      setModularPrice,
      setModularBundledProducts,
      setModularPreConfigProducts,
      setModularParentOrientationOptions,
      setModularSectionalProduct,
      updateAddProductSideBarIsOpen,
      updateModularBundleOrderStatus,
      updateModularTotalPrice,
      updateCurrentModularGalleryProduct,
      setModularCollectionTitle,
    },
  };
};

export default useModularPDPVar;
